module.exports = __webpack_public_path__ + "img/home-img-4.925c1677.webp";